__turbopack_context__.v({
  "avatar": "OwnerCell-module__PTVVMq__avatar",
  "ownerCell": "OwnerCell-module__PTVVMq__ownerCell",
});
